import React, {useEffect, useState} from 'react';
import BtnWhiteBlackBorderBigSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';
import Image from 'app/Components/Shared/Image/image';
const WhiteBtnAssistancePage = ({
  icon,
  title,
  assistanceText,
  assistanceBtnText,
  assistanceBtnTextDesktop,
  assistanceUnderBtnTextDesktop,
  onAssistanceBtnClick,
  footerBtnText,
  onFooterBtnClick,
}) => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia('(max-width: 767px)').matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 767px)');
    const handleChange = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <div className='white-btn-assistance-page'>
      <div className='icon-title-container'>
        {icon && <Image src={icon} className='icon' />}
        {title && <span className='title'>{title}</span>}
      </div>
      {assistanceBtnText && <div className='assistance-text-btn-container'>
        {assistanceText && <span className='assistance-text'>{assistanceText}</span>}
        <BtnWhiteBlackBorderBigSize
          text={isMobile ? assistanceBtnText : assistanceBtnTextDesktop}
          onclick={onAssistanceBtnClick}
        />
        {!isMobile && assistanceUnderBtnTextDesktop && <span className='assistance-under-btn-text'>{assistanceUnderBtnTextDesktop}</span>}
      </div>}
      <div className='footer-white-btn-container'>
        <BtnWhiteBlackBorderBigSize
          text={footerBtnText}
          onclick={onFooterBtnClick}
        />
      </div>
    </div>
  );
};

export default WhiteBtnAssistancePage;
